import friendlyDate from '../../Utils/FriendlyDate';
import t from "../../Utils/Translation";
import './timelineBox.css'

const TimelineBox = (props)=>{
    const userHistoryItems = props.userHistoryItems;
    
    return <div className="col-xl-4 col-md-6 lykiocss-profile-text-color">
            <div className="card">
                <div className="card-block">
                    <div className="row align-items-center justify-content-center">
                        <div className="col">
                            <div className='lykiocss-center lykiocss-subtitle-light'>{t("Timeline (last 5 entries)")}</div>
                        </div>
                    </div>
                    <ul className="task-list">
                        {userHistoryItems && userHistoryItems.slice(0).reverse().map((historyItem, index) =>{
                            if(index<5){
                                return <li>
                                <i className="task-icon bg-c-green"></i>
                                <span className="float-right">{localStorage.getItem("i18n") === "el"
                                ? historyItem.message
                                    .replace("viewed", "είδε")
                                    .replace("added a new profile picture", "πρόσθεσε νέα φωτογραφία προφίλ")
                                    .replace("logged in", "συνδέθηκε")
                                    .replace("rated", "αξιολόγησε")
                                    .replace("commented on", "σχολίασε το")
                                    .replace("earned", "κέρδισε")
                                    .replace("leveled up to level", "ανέβηκε στο επίπεδο")
                                    .replace("created", "δημιουργήθηκε")
                                : localStorage.getItem("i18n") === "fi"
                                ? historyItem.message
                                    .replace("viewed", "katsoi")
                                    .replace("added a new profile picture", "lisäsi uuden profiilikuvan")
                                    .replace("logged in", "kirjautui sisään")
                                    .replace("rated", "arvosteltu")
                                    .replace("commented on", "kommentoi")
                                    .replace("earned", "ansaitsi")
                                    .replace("leveled up to level", "saavutti tason")
                                    .replace("created", "luotu")
                                : localStorage.getItem("i18n") === "fr"
                                ? historyItem.message
                                    .replace("viewed", "vu")
                                    .replace("added a new profile picture", "a ajouté une nouvelle photo de profil")
                                    .replace("logged in", "connecté")
                                    .replace("rated", "évalué")
                                    .replace("commented on", "a commenté sur")
                                    .replace("earned", "gagné")
                                    .replace("leveled up to level", "a atteint le niveau")
                                    .replace("created", "créé")
                                : localStorage.getItem("i18n") === "bg"
                                ? historyItem.message
                                    .replace("viewed", "видя")
                                    .replace("added a new profile picture", "добави нова профилна снимка")
                                    .replace("logged in", "влезе в системата")
                                    .replace("rated", "оценена")
                                    .replace("commented on", "коментира за")
                                    .replace("earned", "спечели")
                                    .replace("leveled up to level", "достигна ниво")
                                    .replace("created", "създаден")
                                : historyItem.message}</span>
                                <p className="text-muted">{t("on")} {friendlyDate(historyItem.creationDate)}</p>
                                </li>
                            }
                        })}
                    </ul>
                </div>
            </div>
        </div>
}

export default TimelineBox;